import _ from 'lodash';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export const getPermissionsFromRole = (role) => {
    let permissions = [];
    if (role.permissions) {
      permissions =  _.map(role.permissions, 'codename')
    }
    return permissions
}


export const errorMsgCreator= (msg, data) => {
  if (Object.keys(data).length !== 0 ) {
    msg += `${data[Object.keys(data)[0]]}`
  }
  return msg
}

export const truncateText = (text, maxLength = 20, placement = 'auto') => {
    if (!text) return '-';

    if (text.length <= maxLength) return text;

    const truncated = text.substring(0, maxLength) + '...';
    
    return (
        <OverlayTrigger
            placement={placement}
            overlay={
                <Tooltip 
                    style={{ 
                        maxWidth: '350px',
                        width: 'max-content',
                        wordWrap: 'break-word',
                        whiteSpace: 'normal'
                    }}
                >
                    {text}
                </Tooltip>
            }
            popperConfig={{
                modifiers: [
                    {
                        name: 'flip',
                        enabled: true,
                        options: {
                            fallbackPlacements: ['bottom', 'top', 'right', 'left'],
                            allowedAutoPlacements: ['top', 'bottom', 'right', 'left'],
                        },
                    },
                    {
                        name: 'preventOverflow',
                        enabled: true,
                        options: {
                            boundary: 'viewport',
                            padding: 8,
                        },
                    },
                    {
                        name: 'offset',
                        enabled: true,
                        options: {
                            offset: [0, 8],
                        },
                    },
                ],
            }}
        >
            <span style={{ cursor: 'pointer' }}>{truncated}</span>
        </OverlayTrigger>
    );
};

export const truncateTextOnly = (text, maxLength = 30) => {
    if (!text) return '-';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
};